// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 18'
    ...attributes
  ><path
      fill='var(--icon-color, #000)'
      d='M2.574 9.707A18.5 18.5 0 0 0 4.6 12.316C6.776 14.632 9.255 16 12 16s5.224-1.368 7.4-3.684a18.5 18.5 0 0 0 2.03-2.609q.245-.38.434-.707a17 17 0 0 0-.434-.707 18.5 18.5 0 0 0-2.03-2.609C17.224 3.368 14.745 2 12 2S6.776 3.368 4.6 5.684a18.5 18.5 0 0 0-2.03 2.609q-.245.38-.434.707.195.328.438.707M.106 8.553a15 15 0 0 1 .789-1.345 20.5 20.5 0 0 1 2.251-2.891C5.661 1.632 8.62 0 12 0s6.339 1.632 8.855 4.316a20.5 20.5 0 0 1 2.251 2.891 15 15 0 0 1 .789 1.345 1 1 0 0 1 0 .894 15 15 0 0 1-.789 1.345 20.5 20.5 0 0 1-2.251 2.891C18.339 16.368 15.38 18 12 18s-6.339-1.632-8.855-4.316a20.5 20.5 0 0 1-2.251-2.891 15 15 0 0 1-.788-1.346 1 1 0 0 1 0-.894M12 12a3 3 0 0 1-3-3 3 3 0 0 1 3-3 3 3 0 0 1 3 3 3 3 0 0 1-3 3'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'Eye';
export default IconComponent;
